export default {"src":"/_next/static/media/remove-wishlist.38d69e57.svg","height":15,"width":15};